import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button, FormGroup } from 'reactstrap';
import {
  dobIsRequired,
  isRequired,
  validateCustomerByAge,
} from '../../../../utils/validators';
import {
  getItineraryFoodGroup,
  deselectSeat,
  clearCustomers,
} from '../../../../actions/';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';
import Select from '../../../common/forms/select/Select';
import { orderBy } from '../../../../utils/array';
import FormItem from '../../../common/forms/FormItem';
import {
  RELATIONSHIP,
  RELATIONSHIP_TO_MINOR,
  RELATIONSHIP_WITH_PERMIT,
} from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';
import TextInput from '../../../common/forms/input/TextInput';
import Badge from '../../../common/Badge';
import { tzNormalizeDate } from '../../../../utils/date';
import KidPassengerForm from './KidPassengerForm';

class PassengerForm extends Component {
  static hasValidSeat({ value }, allValues) {
    let duplicateCount = 0;
    allValues.passengers.forEach((passenger) => {
      const { seatReservation } = passenger;
      if (seatReservation && seatReservation.value === value) {
        duplicateCount += 1;
      }
    });

    return duplicateCount >= 2 ? 'Asiento repetido' : undefined;
  }

  constructor(props) {
    super(props);

    this.state = {
      customerDisabled: false,
      underageDisabled: true,
      showUnderageExtraFields: false,
      grownUpPassenger: null,
      underagePassenger: null,
      relationship: null,
      needNotarizedPermit: false,
      isValidAge: true,
      isAgeBetween15And18: false,
      travelsOnly: false,
      showKidForm: false,
    };
  }

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    const { dispatchGetItineraryFoodGroup, itineraryId } = this.props;

    dispatchGetItineraryFoodGroup(itineraryId);

    this.validateSelfServiceCustomer();
  };

  onChangeGrownUpPassenger = (customer) => {
    const { passenger, dispatchChange, dispatchClearCustomers } = this.props;

    dispatchClearCustomers();

    const selectedCustomer = customer && customer.firstName;

    const validAge = customer && validateCustomerByAge(customer);
    const validAgeBetween15And18 =
      customer && !validAge && validateCustomerByAge(customer, 15);

    if (customer && validAge) {
      dispatchChange('PassengersForm', `${passenger}.parent`, null);
    } else {
      dispatchChange(
        'PassengersForm',
        `${passenger}.parent.relationship`,
        null,
      );
    }

    this.setState({
      grownUpPassenger: customer && customer.fullName,
      underagePassenger: null,
      relationship: null,
      showUnderageExtraFields: !validAge,
      underageDisabled: !selectedCustomer || validAge,
      isValidAge: validAge,
      isAgeBetween15And18: validAgeBetween15And18,
      travelsOnly: false,
      needNotarizedPermit: false,
    });
  };

  onChangeUnderagePassenger = (customer) => {
    const { passenger, dispatchChange } = this.props;

    dispatchChange('PassengersForm', `${passenger}.parent.relationship`, null);

    this.setState({
      relationship: null,
      needNotarizedPermit: false,
      travelsOnly: false,
      underagePassenger: customer && customer.fullName,
    });
  };

  onChangeRelationship = (relationship) => {
    this.setState({ relationship: relationship && relationship.label });

    if (relationship && relationship.label) {
      this.setState({
        needNotarizedPermit: Object.values(RELATIONSHIP_WITH_PERMIT).some(
          (r) => r.label === relationship.label,
        ),
      });
      if (relationship.label === RELATIONSHIP_TO_MINOR.TRAVELS_ALONE.label) {
        this.setState({ travelsOnly: true });
      } else {
        this.setState({ travelsOnly: false });
      }
    } else {
      this.setState({ needNotarizedPermit: false });
    }
  };

  onClickDeselectSeat = () => {
    const { seatReservations, index, dispatchDeselectSeat, fields } =
      this.props;

    const {
      value: seatReservationId,
      label: seatId,
      itineraryId,
    } = seatReservations[index];
    fields.remove(index);

    dispatchDeselectSeat({
      seatReservationId,
      itineraryId,
      seatId,
    });
  };

  handleToggleKidForm = () => {
    const { showKidForm } = this.state;
    const { passenger, dispatchChange } = this.props;
    if (showKidForm) {
      this.setState({ showKidForm: false });
      dispatchChange('PassengersForm', `${passenger}.kid`, null);
    } else {
      this.setState({ showKidForm: true });
    }
  };

  validateSelfServiceCustomer = () => {
    // const { selfServiceCustomer, dispatchChange, passenger } = this.props;
    // if (selfServiceCustomer) {
    //   const passengerValue = {
    //     value: selfServiceCustomer.value,
    //     label: selfServiceCustomer.label,
    //   };
    //   dispatchChange(
    //     'PassengersForm',
    //     `${passenger}.passenger`,
    //     passengerValue,
    //   );
    //   this.setState({ customerDisabled: true });
    // }
  };

  render() {
    const {
      seatReservations,
      index,
      foodOptions,
      seatSelectionChangesInProgress,
      passenger,
      selfServiceCustomer,
    } = this.props;

    const {
      customerDisabled,
      underageDisabled,
      showUnderageExtraFields,
      grownUpPassenger,
      underagePassenger,
      relationship,
      needNotarizedPermit,
      travelsOnly,
      showKidForm,
      isValidAge,
      isAgeBetween15And18,
    } = this.state;

    let foodInput = null;
    if (foodOptions) {
      foodInput = (
        <FormGroup row>
          <FormItem label="Alimento" required>
            <Field
              name={`${passenger}.food`}
              component={Select}
              options={foodOptions}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      );
    }

    let route = null;
    let deleteButton = null;
    if (seatReservations[index]) {
      const {
        itinerary: {
          originName,
          destinationName,
          serviceName,
          departureTime,
          arrivalTime,
        },
      } = seatReservations[index];

      // departure
      const formattedDepartureTime = tzNormalizeDate({
        date: departureTime,
        format: DATE_TIME_FORMAT,
      });

      // arrival
      const formattedArrivalTime = tzNormalizeDate({
        date: arrivalTime,
        format: DATE_TIME_FORMAT,
      });

      route = (
        <>
          <div className="mr-2">({serviceName})</div>
          <div className="text-center">
            {originName}{' '}
            <p>
              <small>{formattedDepartureTime}</small>
            </p>
          </div>
          <div className="mr-3 ml-3"> &rarr; </div>
          <div className="text-center">
            {destinationName}{' '}
            <p>
              <small>{formattedArrivalTime}</small>
            </p>
          </div>
        </>
      );

      let deselectSeatFunction = null;

      if (seatSelectionChangesInProgress.size === 0) {
        deselectSeatFunction = this.onClickDeselectSeat;
      }

      deleteButton = (
        <i
          className="fa fa-times fa-2x text-danger clickable"
          role="button"
          onClick={deselectSeatFunction}
          onKeyPress={deselectSeatFunction}
          tabIndex={0}
        />
      );
    }

    const kidForm = (
      <>
        <br />
        <br />
        <KidPassengerForm passenger={passenger} form="PassengersForm" />
      </>
    );

    const header = (
      <div className="clearfix">
        <div className="float-left">
          <h5>
            <div className="d-flex">
              <div className="mr-3">Pasajero {index + 1}: </div> {route}
            </div>
          </h5>
        </div>
        <div className="float-right">{deleteButton}</div>
      </div>
    );

    const underageExtraFields = showUnderageExtraFields && (
      <>
        <FormGroup row>
          <FormItem label="Relación con el Menor" required>
            <Field
              name={`${passenger}.parent.relationship`}
              component={Select}
              options={
                isAgeBetween15And18
                  ? enumToSelectOptions(RELATIONSHIP_TO_MINOR)
                  : enumToSelectOptions(RELATIONSHIP)
              }
              onChange={this.onChangeRelationship}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        {needNotarizedPermit && (
          <>
            <div className="alert alert-info">
              <i className="fa fa-info-circle mr-2" />
              Se requiere permiso notariado para que el menor pueda viajar.
            </div>
            <FormGroup row>
              <FormItem label="Permiso Notariado">
                <Field
                  name={`${passenger}.parent.notarizedPermit`}
                  component={TextInput}
                  type="text"
                  placeholder="Ingresar Permiso Notariado"
                />
              </FormItem>
            </FormGroup>
          </>
        )}
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name={`${passenger}.parent.comments`}
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
            />
          </FormItem>
        </FormGroup>
      </>
    );

    let relationshipText = null;
    if (RELATIONSHIP_TO_MINOR.TRAVELS_ALONE.label === relationship) {
      relationshipText = `${underagePassenger} viaja solo`;
    } else if (RELATIONSHIP.OTHER.label === relationship) {
      relationshipText = `${underagePassenger} tiene otro tipo de relación con ${grownUpPassenger}`;
    } else {
      relationshipText = `${underagePassenger} es ${relationship} de ${grownUpPassenger}`;
    }

    const underageDetails = underagePassenger &&
      grownUpPassenger &&
      relationship && (
        <Badge color="success" text={<small>{relationshipText}</small>} />
      );

    const kidFormButtonText = showKidForm ? (
      <Fragment>
        <i className="fa fa-minus-circle" /> Quitar Menor de 5 años
      </Fragment>
    ) : (
      <Fragment>
        <i className="fa fa-plus-circle" /> Menor de 5 años
      </Fragment>
    );

    return (
      <div>
        <hr />
        {header}
        <CustomerInputGroup
          label="Pasajero"
          labelRequired
          name={`${passenger}.passenger`}
          form="PassengersForm"
          mobilePhoneRequired
          disabled={customerDisabled}
          onChange={this.onChangeGrownUpPassenger}
          onEditOrSaveCustomer={(customer) =>
            this.onChangeGrownUpPassenger(customer)
          }
          showDetails={!selfServiceCustomer}
          showDiscountMessage
          searchByDocumentNumber={selfServiceCustomer}
          useBookingSearch
          canEditNames
        />
        <FormGroup row>
          <FormItem label="">
            <Button
              color="primary"
              outline
              size="sm"
              type="button"
              onClick={this.handleToggleKidForm}
            >
              {kidFormButtonText}
            </Button>{' '}
            {showKidForm && kidForm}
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Asiento" required>
            <Field
              name={`${passenger}.seatReservation`}
              component={Select}
              options={seatReservations}
              isDisabled
              validate={[isRequired, PassengerForm.hasValidSeat]}
            />
          </FormItem>
        </FormGroup>
        {foodInput}
        {!selfServiceCustomer ? (
          <div className="mr-3 ml-3 border rounded shadow-sm">
            <div className="pt-3 pr-3 pl-3 pb-1">
              <h5>Datos del Adulto de Responsable: {underageDetails}</h5>
              {!travelsOnly && (
                <CustomerInputGroup
                  label="Pasajero"
                  name={`${passenger}.parent.customer`}
                  form="PassengersForm"
                  disabled={underageDisabled}
                  onChange={this.onChangeUnderagePassenger}
                  disabledCreateCustomer
                  onEditOrSaveCustomer={() => {}}
                  validate={isValidAge ? [] : [isRequired, dobIsRequired]}
                  showDetails
                  isClearable
                  useBookingSearch
                  canEditNames
                />
              )}
              {underageExtraFields}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

PassengerForm.propTypes = {
  index: PropTypes.number.isRequired,
  passenger: PropTypes.string.isRequired,
  foodOptions: Select.propTypes.options,
  seatReservations: Select.propTypes.options.isRequired,
  dispatchGetItineraryFoodGroup: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  itineraryId: PropTypes.number.isRequired,
  dispatchDeselectSeat: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.object.isRequired,
  seatSelectionChangesInProgress: PropTypes.instanceOf(Immutable.Set)
    .isRequired,
  selfServiceCustomer: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
    salesSessionUserId: PropTypes.number,
  }),
  dispatchClearCustomers: PropTypes.func.isRequired,
};

PassengerForm.defaultProps = {
  selfServiceCustomer: null,
  foodOptions: null,
};

const mapStateToProps = (state, { index }) => {
  const seatReservations = state.BookingUnit.Booking.getIn([
    'seats',
    'seatReservations',
  ])
    .map((seatReservation) => ({
      value: seatReservation.id,
      label: seatReservation.seat.seatNumber,
      itinerary: seatReservation.itinerary || null,
      itineraryId: seatReservation.itineraryId || null,
      seatNumber: seatReservation.seat.seatNumber,
      floorNumber: seatReservation.seat.floorNumber,
    }))
    .toJS();

  const seatReservationsOrdered = orderBy(
    seatReservations,
    ['itinerary.departureTime', 'itineraryId', 'label'],
    ['asc'],
  );

  const foodGroup = state.BookingUnit.Booking.getIn([
    'passengers',
    'itineraryFoodGroup',
  ]);

  let foodOptions = null;
  if (foodGroup && foodGroup.foodSet) {
    foodOptions = foodGroup.foodSet.map((food) => ({
      value: food.id,
      label: food.name,
    }));
  }

  const seatSelectionChangesInProgress = state.BookingUnit.Booking.getIn([
    'seats',
    'seatSelectionChangesInProgress',
  ]);

  const { customer, salesSessionUserId } = state.authentication.get('user');

  let selfServiceCustomer;

  if (salesSessionUserId) {
    selfServiceCustomer = {
      value: customer.id,
      label: `${customer.idDocumentNumber} - ${customer.fullName}`,
    };
  }

  const { itineraryId } = seatReservations[index];

  return {
    seatReservations: seatReservationsOrdered,
    foodOptions,
    itineraryId,
    seatSelectionChangesInProgress,
    selfServiceCustomer,
  };
};

const mapDispatchToProps = {
  dispatchGetItineraryFoodGroup: getItineraryFoodGroup,
  dispatchChange: change,
  dispatchDeselectSeat: deselectSeat,
  dispatchClearCustomers: clearCustomers,
};

export default connect(mapStateToProps, mapDispatchToProps)(PassengerForm);
